import request from '@/utils/request'

export default {
  //获取单位巡查统计
  getUnitPatrolling: function(){
      return request({
          url: '/lcc/getUnitPatrolling',
          method: 'GET',
      })
  },
  getHiddenDangerSection: function(){
      return request({
          url: '/lcc/getHiddenDangerSection',
          method: 'GET'
      })
  },
  getTaskAssignment: function(){
        return request({
            url:'/lcc/getTaskAssignment',
            method: 'GET'
        })
  },
  getProcessingConditions: function(){
      return request({
          url: '/lcc/getProcessingConditions',
          method: 'GET'
      })
  },
  getSourceOfDangerList: function(){
      return request({
          url: '/lcc/getSourceOfDangerList',
          method: 'GET'
      })
  },
  getSourceOfDangerDetail: function(pid){
      return request({
          url: '/lcc/getSourceOfDangerDetail',
          method: 'GET',
          params : pid
      })
  },
  onSubmitDetail: function(data){
      return request({
          url: '/lcc/onSubmitDetail',
          method: 'POST',
          data: data
      })
  },
  doUpload: function(){
      return request({
          url: '/lcc/doUpload',
          method: 'POST',
      })
  },
  getPatrolIfNormal: function(){
      return request({
          url: '/lcc/getPatrolIfNormal',
          method: 'GET'
      })
  },
  getInsertInfo: function(){
      return request({
          url: '/lcc/getInsertInfo',
          method: 'GET'
      })
  },
  confirmSourceOfDanger: function(input){
      return request({
          url: '/lcc/confirmSourceOfDanger',
          method: 'POST',
          data: input
      })
  },
  searchSourceOfDanger: function(name){
      return request({
          url: '/lcc/searchSourceOfDanger',
          method: 'GET',
          params: name
      })
  },
  searchChoseDate: function(params){
      return request({
          url: '/lcc/searchChoseDate',
          method: 'GET',
          params: params
      })
  },
  getAllContingencyPlanList: function(){
      return request({
          url: '/lcc/getAllContingencyPlanList',
          method: 'GET',
      })
  },
  changeContingencyPlanStatus: function(params){
      return request({
          url: '/lcc/changeContingencyPlanStatus',
          method: 'GET',
          params: params
      })
  },
  confirmTrainMsg: function(data){
      return request({
          url:'/lcc/confirmTrainMsg',
          method: 'POST',
          data: data
      })
  },
  queryTrainList: function(data){
      return request({
          url: '/lcc/queryTrainList',
          method: 'POST',
          data: data
      })
  },
  deleteMeetingPlan: function(data){
      return request({
          url: '/lcc/deleteMeetingPlan',
          method: 'GET',
          params: data
      })
  }
}



// WEBPACK FOOTER //
// ./src/api/lcc.js